import * as React from 'react';
import {useEffect, useRef} from 'react';
import ErrorDisplay from '../../shared/ErrorDisplay';

interface InboundErrorsProps {
  errors: string[];
}

const InboundErrors: React.FunctionComponent<InboundErrorsProps> = (props: InboundErrorsProps) => {
  const errorRef = useRef<HTMLDivElement>(null);
  const {errors} = props;

  // scroll to the error
  useEffect(() => {
    if (errors.length > 0 && errorRef.current) {
      errorRef.current.scrollIntoView({behavior: 'smooth'});
    }
  }, [errors]);

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="col-md-12 space-below" ref={errorRef}>
      <ErrorDisplay errorText={errors.join(' ')} />
    </div>
  );
};

export default InboundErrors;
